export default __webpack_public_path__ + "static/media/Tsx.1e41f584.png";